import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const FILTERS_SET_BEDS_COUNT = 'filters/set_beds_count' as const;

export const setBedsCount = actionGenerator<typeof FILTERS_SET_BEDS_COUNT, number | undefined>(FILTERS_SET_BEDS_COUNT);

export type TSetBedsCountAction = ReturnType<typeof setBedsCount>;
